/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/textpattern/TextPatternScannerUIResult.yaml
import { ToJsonConfiguration } from '../../common/JsonSerializationTypes';
import { SymbolBox, WordBox } from '../../text_pattern/TextPatternScannerTypes';
/**
Configuration of the generic text scanner RTU UI result.
*/
export class TextPatternScannerUiResult {
    /** @param source {@displayType `DeepPartial<TextPatternScannerUiResult>`} */
    constructor(source = {}) {
        /**
          Confidence of the recognition.
          
          Default is 0.0
          */
        this.confidence = 0.0;
        if (source.rawText !== undefined) {
            this.rawText = source.rawText;
        }
        else {
            throw new Error('rawText must be present in constructor argument');
        }
        if (source.wordBoxes !== undefined) {
            this.wordBoxes = source.wordBoxes.map((it) => {
                return new WordBox(it);
            });
        }
        else {
            throw new Error('wordBoxes must be present in constructor argument');
        }
        if (source.symbolBoxes !== undefined) {
            this.symbolBoxes = source.symbolBoxes.map((it) => {
                return new SymbolBox(it);
            });
        }
        else {
            throw new Error('symbolBoxes must be present in constructor argument');
        }
        if (source.confidence !== undefined) {
            this.confidence = source.confidence;
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            rawText: this.rawText,
            wordBoxes: this.wordBoxes.map((it) => {
                return it.serialize(config);
            }),
            symbolBoxes: this.symbolBoxes.map((it) => {
                return it.serialize(config);
            }),
            confidence: this.confidence,
        };
    }
}
//# sourceMappingURL=TextPatternScannerUiResult.js.map